import React, { useCallback, useState, useRef } from "react";
import MaterialReactTable from "material-react-table";
import { useDispatch } from "react-redux";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import { getListReglement } from "../../Redux/reglementReduce";
import jwt_decode from "jwt-decode";
import { toast, ToastContainer } from "react-toastify";
import { useHistory } from "react-router-dom";
import { verification } from "../../Redux/usersReduce";
import { useTranslation } from 'react-multi-lang';
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";

function ListReglement({ client }) {
  let lang = window.localStorage.getItem("lang");
  const t = useTranslation();
  const dispatch = useDispatch();
  const navigate = useHistory();
  var token = localStorage.getItem("x-access-token");
  var annee = localStorage.getItem("annee");
  var decoded = jwt_decode(token);
  var idUser = decoded.id;
  const [loader, setLoader] = useState(true);
  const [data, setData] = useState([]);
  const [alert, setAlert] = useState(null);



  const idRole = useRef(0);

  const setIdRole = (newValue) => {
    idRole.current = newValue;
  };

  const [columnsAfc] = useState([
    {
      id: "Tiers",
      header: t("Wholesaler"),
      accessorKey: "TiersFacture",
    },
    {
      id: "No_facture",
      header: t("No_facture"),
      accessorKey: "NumPiece",
    },
    {
      id: "Mode_reglement",
      header: t("Mode_reglement"),
      accessorKey: "ModeReglement",
    },
    {
      id: "Date_echeance",
      header: t("Date_echeance"),
      accessorKey: "DateEcheance",
    },
    {
      id: "Montant_TND",
      header: t("Montant_TND"),
      accessorKey: "DeviseRef",
       Cell: ({ cell }) => {
        const value = parseFloat(cell.row.original.DeviseRef) || 0;
        return (
          <div className="block_action">
            {new Intl.NumberFormat('fr-FR', {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3
            }).format(value)}
          </div>
        );
      }
    },
  ]);

const [columns] = useState([
  {
    id: "No_facture",
    header: t("No_facture"),
    accessorKey: "NumPiece",
  },
  {
    id: "Mode_reglement",
    header: t("Mode_reglement"),
    accessorKey: "ModeReglement",
  },
  {
    id: "Date_echeance",
    header: t("Date_echeance"),
    accessorKey: "DateEcheance",
  },
  {
    id: "Montant_TND",
    header: t("Montant_TND"),
    accessorKey: "DeviseRef",
    Cell: ({ cell }) => {
      const value = parseFloat(cell.row.original.DeviseRef) || 0;
      return (
        <div className="block_action">
          {new Intl.NumberFormat('fr-FR', {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3
          }).format(value)}
        </div>
      );
    }
  },
]);

function ListTable({ list, loader }) {
  return (
    <MaterialReactTable
      state={{ isLoading: loader }}
      columns={idRole.current == 6 ? columns : columnsAfc}
      data={list}
      enableColumnActions={true}
      enableColumnFilters={true}
      enablePagination={true}
      enableSorting={true}
      enableBottomToolbar={true}
      enableTopToolbar={true}
      muiTableBodyRowProps={{ hover: false }}
      displayColumnDefOptions={{
        'mrt-row-numbers': {
          size: 10,
        },
        'mrt-row-expand': {
          size: 10,
        },
      }}
      enableColumnFilterModes
      initialState={{
        columnVisibility: { description: false },
        density: 'compact',
        showGlobalFilter: true,
      }}
      muiSearchTextFieldProps={{
        placeholder: t("search"),
        sx: { minWidth: '18rem' },
        variant: 'outlined',
      }}

      filterFns={{
        myCustomFilterFn: (row, id, filterValue) => {
          const value = row.getValue(id);
          return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
        },
      }}
      globalFilterFn="myCustomFilterFn"

      localization={
        lang === "fr"
          ? MRT_Localization_FR
          : MRT_Localization_EN
      }
    />
  );
}
const verifToken = useCallback(async () => {
  var response = await dispatch(verification());
  if (response.payload === false) {
    localStorage.clear();
    window.location.replace("/login");
  } else {
    setIdRole(response.payload.id_role)
  }
}, [dispatch]);


const notify = (type, msg) => {
  if (type === 1)
    toast.success(<strong>{msg}</strong>);
  else
    toast.error(<strong>{msg}</strong>);
}






const fectchListReglement = useCallback(
  async (idUser, client) => {
    var etat = idRole.current == 5 ? [1] : [0];
    var list = await dispatch(
      getListReglement({
        id_user: idUser,
        etat, annee, client
      })
    );
    var res = list.payload.map(reglement => ({
      ...reglement,
      checked: false
    }));

    setLoader(false);
    setData(res);
  },
  [dispatch]
);


function detailsReglement(id) {
  navigate.push(client + "/detailsReglement/" + id);
}


React.useEffect(() => {
  const fetchData = async () => {
    await verifToken();
    if (idRole.current > 0) {
      fectchListReglement(idUser, client);
    }
  };

  fetchData();
}, [idRole.current]);

return (
  <>
    {alert}
    <Container fluid>
      <ToastContainer />

      <Row>

        <Col md="12">
          <Card>
            <Card.Header>
              <Card.Title as="h4">{t("mes_reglement")}</Card.Title>
              <br clear="all"></br>
            </Card.Header>
            <Card.Body className="table-style">
              <ListTable list={data} loader={loader} ></ListTable>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  </>
);
}

export default ListReglement;
